import {GameMode} from '@nolimitcity/slot-game/bin/flowcontrol/GameMode';
import {StateHandler} from '../../../../../core/utils/StateHandler';
import {Presentation} from '../../../../../core/gameflow/controller/Presentation';
import {WinGameData} from '../../../../server/data/GameDataModels';
import {GameData} from '../../../../server/data/GameData';
import {GameConfig} from '../../../../config/base/GameConfig';
import {IBetWayWinData} from '../../../../server/base/IData';
import {GameSetting} from '../../../../../core/setting/GameSetting';
import {PunkSymbol} from '../../../../punkEngine/symbol/PunkSymbol';
import {PREngineManager} from '../../../../punkEngine/PREngineManager';
import {SoundManager} from '../../../../sound/SoundManager';
import {SoundConfig} from '../../../../sound/SoundConfig';
import {PunkRocker} from '../../../../PunkRocker';
import {IAllWinData} from '@nolimitcity/slot-game/bin/utils/server/IData';
import {ArrayHelper} from '../../../../../core/utils/ArrayHelper';
import {NJReqIndividualWinView} from "./NJReqIndividualWinView";

class WinState extends StateHandler {
    public static readonly WIN: string = "win";
    public static readonly SMALL_WIN: string = "small_win";
    public static readonly NORMAL: string = "normal";
    public static readonly BIGWIN: string = "bigwin";
    public static readonly DONE: string = "done";
}

export class NormalWinPresentation extends Presentation {

    private winData: WinGameData;
    private _winState: WinState = new WinState();

    private winAmount: number = 0;

    private bigWin: boolean = false;
    private winIndex: number = 0;

    private winConfigDurr: number = 0;
    private lastNormalIndex: number = 0;

    private noWinAlpha: number = 0.45;
    private skipped: boolean = false;
    private skipFunc: Function;

    private isBelowStake: boolean = false;
    private isIndividualBelowStake: boolean = false;
    private isTotalWin: boolean = false;
    private _isBonusGame: boolean = false;

    public checkForActivation(data: GameData): boolean {
        return !data.raw.brokeTheBank && !!data.Win.singleWin;
    }

    public initialization(): void {
        this.lastNormalIndex = GameConfig.WIN_RATIOS.normalWin.length - 1;
    }

    preStart(): void {
        this.skipped = false;
    }

    public setGamedData(data: GameData): void {
        this.winData = data.Win;

        this._isBonusGame = data.isFreeSpin;

        this.bigWin = this.winData.isBigWin;
        this._winState.set(WinState.WIN);

        //console.log(this.winData);

        this.isTotalWin = data.mode !== GameMode.NORMAL || data.nextMode !== GameMode.NORMAL;

        this.winAmount = !this.bigWin ? this.winData.singleWin : this.winData.playedBetValue * GameConfig.WIN_RATIOS.bigWin[0].ratio;

        this.winIndex = GameConfig.WIN_RATIOS.normalWin.findIndex((index) => index.ratio == this.winData.winRatioConfig.ratio);
        if (this.winIndex == -1) this.winIndex = this.lastNormalIndex;

        this.winConfigDurr = GameConfig.WIN_RATIOS.normalWin[this.winIndex].duration;
        this.isIndividualBelowStake = data.Win.isIndiviWinBelowStake();
        this.isBelowStake = data.Win.isWinBelowStake!();
    }

    createPresentation(skip: Function): void {
        this.skipFunc = skip;

        switch (this._winState.value) {
            case WinState.WIN:
                this.skipFunc(!this.bigWin);
                this.winPositions();
                this._winState.set(this.bigWin ? WinState.DONE : WinState.NORMAL);
                if (this.isBelowStake) {
                    this._winState.set(WinState.DONE);
                }
                break;
            case WinState.NORMAL:
                this.skipFunc(!this.bigWin);
                this.addWinCountUpToTimeline();
                this._winState.set(WinState.DONE);
                break;
            default:
                if (!this.bigWin) {
                    this.timeline.to(this, {duration: 0.15});
                }
                this.PresentationState.setInactive();
                break;
        }
    }

    public skip(): void {
        if (this._winState.equal(WinState.DONE)) {
            this.skipped = true;
        }
        super.skip();
    }

    public done(): void {
        if (!this.bigWin) {
            PunkRocker.keypadPlugin.setWin(this.winData!.totalWin, this.isTotalWin, this.isBelowStake);
            if (this.skipped) {
                PunkRocker.counter.stop(this.winAmount, 0.25, 0.25).add(() => this.removeSymFrames(0.25), 0.25);
            } else {
                PunkRocker.counter.stop(this.winAmount, 0.5, 1).add(() => this.removeSymFrames(0.25), 1);
            }
        } else {
            // this.removeSymFrames(0);
        }
    }

    protected winPositions(): void {
        //const perRow: number = GameSetting.isFastSpin ? 0.135 : 0.18;
        const animationDurr: number = 0.5,
            winGroups: IBetWayWinData[] = this.winData.betWayWins!;

        if (this.isIndividualBelowStake) {
            //do nothing
        } else if (winGroups.length == 1) {
            return;
        }

        let startPos: number = 0;

        for (let groups: number = 0; groups < winGroups.length; groups++) {
            const winData: IBetWayWinData = winGroups[groups];
            if (!this.isBelowStake) {
                this.timeline.add(() => {
                    SoundManager.playSoundEffect("betlineHighlightTiny");
                }, startPos);
            }
            for (let reel: number = 0; reel < winData.reelWinPositions.length; reel++) {
                let posRow: boolean[] = winData.reelWinPositions[reel];

                for (let row: number = 0; row < posRow.length; row++) {
                    const sym: PunkSymbol | undefined = PREngineManager.getReel(reel).getSymbol(row),
                        lastWinSymId: number = winData.reelWinPositions[reel].lastIndexOf(true),
                        lastWinSym: PunkSymbol | undefined = PREngineManager.getReel(reel).getSymbol(lastWinSymId);

                    if (sym) {
                        if (reel === (winData.length - 1) && (row === lastWinSymId) && lastWinSym && !(this.winData.isWinBelowStake())) {
                            const posXBuffer: number = winData.reelWinPositions[reel].length === 3 ? 0 : -5,
                                posYBuffer: number = winData.reelWinPositions[reel].length === 3 ? 0 : 0,
                                winWaysObj: NJReqIndividualWinView = new NJReqIndividualWinView(winData.multipliedAmount, winData.numberOfCombinations, new PIXI.Point((PREngineManager.getReel(reel).position.x + posXBuffer), (lastWinSym.position.y + posYBuffer)));

                            PunkRocker.fadedWinView.addWinWays(winWaysObj);
                            this.timeline.add(() => {
                                winWaysObj.showWinAndWays(0.75).eventCallback("onComplete", () => {
                                    PunkRocker.fadedWinView.removeWinWays(winWaysObj);
                                });
                            });
                        }

                        this.timeline.add(() => sym.markNonWin(!posRow[row], this.noWinAlpha, animationDurr / 2), startPos);
                        if (posRow[row]) {
                            this.timeline.add(() => {
                                sym.playFlash(animationDurr);
                            }, startPos);
                        }
                    }
                }
            }
            startPos += animationDurr / 2;
        }
        this.timeline.to(this, {duration: animationDurr / (this.bigWin ? 1.75 : 1.5)})
    }

    protected addWinCountUpToTimeline(): void {

        let countUpDuration: number = this.winConfigDurr,
            animDurr: number = countUpDuration ? 0.5 : 0.3;

        const allWins: IAllWinData = this.winData.allBetWayWinData!,
            splitDurr = countUpDuration / allWins.longest;// - (animDurr / allWins.longest)/2;

        let startPos: number = 0;
        let waysDelay: number = countUpDuration ? 0.2 : 0;
        const perReel: number = countUpDuration ? GameSetting.isFastSpin ? splitDurr * 0.7 : splitDurr : 0;
        if (!this.isBelowStake) {
            this.timeline.add(() => {
                SoundManager.playSoundEffect(SoundConfig.NORMAL_TOTAL_WINS[this.winIndex]);
                if (this.winData.betWayWins!.length > 0) {
                    SoundManager.playSoundEffect("betlineHighlight");
                }
            }, startPos);
        }

        if (countUpDuration) {
            for (let reel = 0; reel < allWins.reelWinPositions.length; reel++) {
                for (let row = 0; row < allWins.reelWinPositions[reel].length; row++) {
                    const sym: PunkSymbol | undefined = PREngineManager.getReel(reel).getSymbol(row);
                    if (sym) {
                        const hits: boolean = allWins.reelWinPositions[reel][row];
                        this.timeline.add(() => {
                            if (hits) {
                                if (this.winIndex > 1) {
                                    sym.playWin(hits, animDurr, allWins.biggestWinLvl, this._isBonusGame);
                                } else {
                                    sym.playFlash(animDurr);
                                }
                            }
                            sym.markNonWin(!hits, undefined, animDurr);
                        }, startPos);
                    }
                }
                if (reel < allWins.longest) {
                    startPos += perReel;
                }
            }
        }

        for (let reel = 0; reel < allWins.reelWinPositions.length; reel++) {
            for (let row = 0; row < allWins.reelWinPositions[reel].length; row++) {
                const sym: PunkSymbol | undefined = PREngineManager.getReel(reel).getSymbol(row),
                    lastWinSymId: number = allWins.reelWinPositions[reel].lastIndexOf(true),
                    lastWinSym: PunkSymbol | undefined = PREngineManager.getReel(reel).getSymbol(lastWinSymId);

                if (sym) {
                    if (reel === (allWins.longest - 1) && (row === lastWinSymId) && lastWinSym && allWins.symbols.length === 1 && !(this.winData.isWinBelowStake())) {
                        const posXBuffer: number = allWins.reelWinPositions[reel].length === 3 ? 0 : -5,
                            posYBuffer: number = allWins.reelWinPositions[reel].length === 3 ? 0 : 0,
                            winWaysObj: NJReqIndividualWinView = new NJReqIndividualWinView(this.winData.betWayWins[0].multipliedAmount, allWins.totalWinCombination, new PIXI.Point((PREngineManager.getReel(reel).position.x + posXBuffer), (lastWinSym.position.y + posYBuffer)));

                        PunkRocker.fadedWinView.addWinWays(winWaysObj);
                        this.timeline.add(() => {
                            winWaysObj.showWinAndWays(0.75).eventCallback("onComplete", () => {
                                PunkRocker.fadedWinView.removeWinWays(winWaysObj);
                            });
                        });
                    }


                    const hits: boolean = allWins.reelWinPositions[reel][row];
                    this.timeline.add(() => {
                        if (hits && this.winIndex <= 1) {
                            sym.playFlash(animDurr);// (animDurr, this.winIndex)
                        }
                        if (!hits) sym.markNonWin(true, this.noWinAlpha);
                    }, startPos);
                    this.timeline.add(() => sym.markNonWin(!hits, this.noWinAlpha, animDurr), startPos + animDurr / 2);
                }
            }
        }

        ArrayHelper.eachForEach(allWins.reelWinPositions, (reel, row, hits) => {
            const sym: PunkSymbol | undefined = PREngineManager.getReel(reel).getSymbol(row);
            if (sym && sym.isWild && !hits) {
                sym.killFire()
            }
        })

        this.timeline.add(() => {
            // SoundManager.playSoundEffect(SoundConfig.WIN_SOUNDS[this.winIndex]);
            PunkRocker.counter.play(0, this.winAmount, countUpDuration, this.winData.totalWinCombination);
        }, 0);
        if (this.winIndex === 2 || this.winIndex === 3) {
            this.timeline.add(() => {
                SoundManager.crossFadeToMain2();
            }, countUpDuration);
        }
        // this.timeline.add(() => {
        //     PunkRocker.counter.bounceHit(this.winIndex);
        //     if(this.winIndex > 1)
        //         PunkRocker.particleManager.triggerWinSplash(false);

        // }, countUpDuration);


        this.timeline.add(() => {
            PunkRocker.counter.showWays(countUpDuration ? countUpDuration : animDurr / 4);
        }, countUpDuration + waysDelay);

        // Reset and remove blackness.
        if (countUpDuration) {
            this.timeline.to(this, {duration: animDurr + countUpDuration + waysDelay + this.winIndex > 2 ? 0.5 : 0}, 0);
        }
    }

    private removeSymFrames(duration: number, ignoreDarknessChange?: boolean): void {
        PREngineManager.RSAll((rc, sym) => {
            sym.stopWin(duration, ignoreDarknessChange);
        })
    }
}